module.exports = __webpack_public_path__ + "static/media/MenuIcon_HBT.0af7513f.svg";